export const GRAPH_NODES = {
    nodes: [
        {
            // @ts-ignore
            id: "billing_account",
            label: "account",
            // @ts-ignore
            category: "billing",
        },
        {
            // @ts-ignore
            id: "billing_credit_memo",
            label: "credit memo",
            // @ts-ignore
            category: "billing",
        },
        {
            // @ts-ignore
            id: "billing_invoice",
            label: "invoice",
            // @ts-ignore
            category: "billing",
        },
        {
            // @ts-ignore
            id: "billing_payment",
            label: "payment",
            // @ts-ignore
            category: "billing",
        },
        {
            // @ts-ignore
            id: "billing_refund",
            label: "refund",
            // @ts-ignore
            category: "billing",
        },
        {
            // @ts-ignore
            id: "billing_subscription",
            label: "subscription",
            // @ts-ignore
            category: "billing",
        },
        {
            // @ts-ignore
            id: "billing_usage",
            label: "usage",
            // @ts-ignore
            category: "billing",
        },
        {
            // @ts-ignore
            id: "erp_account",
            label: "account",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_accounting_book",
            label: "accounting book",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_bill",
            label: "bill",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_bill_credit",
            label: "bill credit",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_bill_credit_item",
            label: "bill credit item",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_bill_payment_items",
            label: "bill payment items",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_billing_schedule",
            label: "billing schedule",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_check",
            label: "check",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_cheque",
            label: "cheque",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_credit_memo",
            label: "credit memo",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_credit_memo_items",
            label: "credit memo items",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_customer",
            label: "customer",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_department",
            label: "department",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_deposit",
            label: "deposit",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_employee",
            label: "employee",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_entries",
            label: "entries",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_expense_report",
            label: "expense report",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_expense_report_items",
            label: "expense report items",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_invoice",
            label: "invoice",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_invoice_items",
            label: "invoice items",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_invoice_shipping_address",
            label: "invoice shipping address",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_item_receipt",
            label: "item receipt",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_journal",
            label: "journal",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_journal_items",
            label: "journal items",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_payment",
            label: "payment",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_payment_items",
            label: "payment items",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_product",
            label: "product",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_purchase_order",
            label: "purchase order",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_purchase",
            label: "purchase",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_refund",
            label: "refund",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_refund_items",
            label: "refund items",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_sales_order",
            label: "sales order",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_sales_order_items",
            label: "sales order items",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_transfer",
            label: "transfer",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "erp_vendor",
            label: "vendor",
            // @ts-ignore
            category: "erp",
        },
        {
            // @ts-ignore
            id: "payments_customer",
            label: "customer",
            // @ts-ignore
            category: "payments",
        },
        {
            // @ts-ignore
            id: "payments_payment",
            label: "payment",
            // @ts-ignore
            category: "payments",
        },
        {
            // @ts-ignore
            id: "payments_payout",
            label: "payout",
            // @ts-ignore
            category: "payments",
        },
        {
            // @ts-ignore
            id: "payments_refund",
            label: "refund",
            // @ts-ignore
            category: "payments",
        },
        {
            // @ts-ignore
            id: "payments_transfer",
            label: "transfer",
            // @ts-ignore
            category: "payments",
        },
        {
            // @ts-ignore
            id: "crm_account",
            label: "account",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_asset",
            label: "asset",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_attachment",
            label: "attachment",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_contract",
            label: "contract",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_installment",
            label: "installment",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_invoice",
            label: "invoice",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_opportunity",
            label: "opportunity",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_opportunity_doc",
            label: "opportunity doc",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_opportunity_items",
            label: "opportunity items",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_mt_doc",
            label: "mt doc",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_mt_doc_items",
            label: "mt doc items",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_of_doc",
            label: "of doc",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_of_doc_items",
            label: "of doc items",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_po_doc",
            label: "po doc",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_po_doc_items",
            label: "po doc items",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_sa_doc",
            label: "sa doc",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_tc_doc",
            label: "tc doc",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_pricebook",
            label: "pricebook",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_pricebook_entry",
            label: "pricebook entry",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_product",
            label: "product",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "crm_quote",
            label: "quote",
            // @ts-ignore
            category: "crm",
        },
        {
            // @ts-ignore
            id: "tax_customer",
            label: "customer",
            // @ts-ignore
            category: "tax",
        },
        {
            // @ts-ignore
            id: "tax_invoice",
            label: "invoice",
            // @ts-ignore
            category: "tax",
        },
        {
            // @ts-ignore
            id: "tax_invoice_items",
            label: "invoice items",
            // @ts-ignore
            category: "tax",
        },
    ],
};
